import { Chip, Stack, Typography } from '@mui/material';

import useLocales from 'src/hooks/useLocales';

import { WorkflowStepKind } from 'src/@types/workflow/types';

import { STEP_KINDS, StepKindIcon } from './stepKind';

type StepTypeChipsProps = {
  stepTypes: string[];
  showOrder?: boolean;
};

export default function StepTypeChips({ stepTypes, showOrder = false }: StepTypeChipsProps) {
  const { t } = useLocales();

  if (stepTypes.length === 0) {
    return (
      <Typography variant="body2" sx={{ color: 'text.disabled' }}>
        {t('workflows.noSteps')}
      </Typography>
    );
  }

  return (
    <Stack direction="row" spacing={0.5} useFlexGap sx={{ flexWrap: 'wrap', gap: 0.5 }}>
      {stepTypes.map((stepType, position) => {
        const kind = stepType as WorkflowStepKind;
        const known = STEP_KINDS[kind];
        const label = known ? t(known.labelKey) : stepType;

        return (
          <Chip
            key={`${stepType}-${position}`}
            size="small"
            color={known?.color ?? 'default'}
            variant="outlined"
            icon={known ? <StepKindIcon kind={kind} fontSize="small" /> : undefined}
            label={showOrder ? `${position + 1}. ${label}` : label}
          />
        );
      })}
    </Stack>
  );
}
